export class ResultFilterData {
  filterDialogContent: any;
}
